import { useEffect } from 'react';
import { useApolloClient } from '@apollo/client';

import { startConsentSync } from '@/layouts/ConsentSync';

/** Syncs Transcend consent for the signed-in session; restarts on token change, stops on sign-out. */
export const useConsentSync = (sessionToken: string | null) => {
  const client = useApolloClient();

  useEffect(() => {
    if (!sessionToken || import.meta.env.VITE_CONSENT_MANAGEMENT_DISABLE_SYNC === 'true') return;

    return startConsentSync(client, sessionToken);
  }, [client, sessionToken]);
};
